// RB-MY01-PalmGarden.web/src/components/PlantForm/components/FormSections/FoliarDetails.tsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import SectionCard from '../SectionCard';
import { FormSectionProps } from '../../types';
import { sectionThemes } from '../../styles';

const FoliarDetails: React.FC<FormSectionProps> = ({ 
  plant
}) => {
  return (
    <SectionCard 
      title="Foliar Details" 
      icon={<i className={sectionThemes.foliarDetails.iconName} style={{ marginRight: '8px' }} />}
      theme={{ color: sectionThemes.foliarDetails.color }}
    >
      <Box sx={{ p: 2 }}>
        <Typography>
          Foliar Details section is under construction.
        </Typography>
      </Box>
    </SectionCard>
  );
};

export default React.memo(FoliarDetails);
